import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=2a47ca1e&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=2a47ca1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47ca1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a47ca1e')) {
      api.createRecord('2a47ca1e', component.options)
    } else {
      api.reload('2a47ca1e', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=2a47ca1e&scoped=true&", function () {
      api.rerender('2a47ca1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/SUI/Controls/Switch/Switch.vue"
export default component.exports